import React from "react";

const RoundedLoadingBar: React.FC = () => (
  <div className="flex justify-center items-center">
    <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-purple-500"></div>
  </div>
);

export default RoundedLoadingBar;
